<script>
  import { quintIn } from "svelte/easing";
  import { afterUpdate } from "svelte";
  import { scale } from "svelte/transition";

  export let value,
    writer,
    className = "small";

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  let result;
  afterUpdate(() => {
    result = formatter.format(value);
  });

  function a(node, param) {
    return {
      update(param) {
        console.log(node, param);
        typewriter(node, `$${param.slice(1)}`);
      },
    };
  }

  function typewriter(node, text, speed = 25) {
    let index = 0;
    console.log(text);
    const interval = setInterval(() => {
      node.textContent = text.slice(0, index);
      index++;
      if (index > text.length) {
        clearInterval(interval);
      }
    }, speed);

    return {
      destroy() {
        clearInterval(interval);
      },
    };
  }
</script>

{#if writer}
  {#key value}
    <div class="position-absolute pt-2" style="top: 0">$</div>
    <div
      transition:scale={{ duration: 250 }}
      class="position-absolute pt-2"
      style="top:0"
    >
      {#if result}
        &nbsp;&nbsp;&nbsp;{result.slice(1)}
      {/if}
    </div>
  {/key}
{:else}
  <span class={className}>{result}</span>
{/if}
